// extracted by mini-css-extract-plugin
module.exports = {"root":"MediaControlButton_root__3M1yq","small":"MediaControlButton_small__2tbjP","active":"MediaControlButton_active__3NT4_","icon":"MediaControlButton_icon__2Q66h"};